// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"style_breadcrumb__1im5T","icon-container":"style_icon-container__11oQg"};